module.exports = __webpack_public_path__ + "img/icon_keyfact.afd403e9.svg";